<div class="d-flex flex-row flex-fill">
  <div class="d-flex flex-fill flex-column m-1 p-3" style="max-width: 50%">
    <dx-data-grid
      #pledgesGrid
      class="flex-fill"
      keyExpr="id"
      [dataSource]="pledges"
      [height]="700"
      [columnAutoWidth]="true"
      [focusedRowEnabled]="false"
      [showBorders]="true"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      (onRowDblClick)="rowDoubleClick($event)"
      >
      <dxi-column dataField="person.displayNameLastFirst" caption="Person" [width]="250" [sortIndex]="1" [sortOrder]="'asc'" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="date" [width]="150" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="amount" caption="Total Amount" [format]="{ type: 'currency', precision: 2 }" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="rowNote" caption="Schedule" width="250" [allowEditing]="false" [encodeHtml]="false" [allowSearch]="true"></dxi-column>
      <dxi-column dataField="givenAmount" caption="Given Amount" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
      <dxi-column dataField="note" caption="Notes" width="250"></dxi-column>
      <dxi-column width="100"></dxi-column>

      <div *dxTemplate="let cell of 'linkTemplate'">
        <a [routerLink]="" (click)="open(cell.data.id)">{{ cell.text || '(blank)' }}</a>
      </div>

      <dxo-export [enabled]="true"></dxo-export>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="pledges-list-grid"></dxo-state-storing>
      <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'onClick'"></dxo-selection>
      <dxo-summary>
        <dxi-total-item column="amount" summaryType="sum" displayFormat="{0}" valueFormat="$#,##0.00"> </dxi-total-item>
        <dxi-total-item column="givenAmount" summaryType="sum" displayFormat="{0}" valueFormat="$#,##0.00"> </dxi-total-item>
      </dxo-summary>
      <div *dxTemplate="let data of 'toolbarButtons'">
        <button class="btn btn-sm btn-success" (click)="open()">Add</button>
        <button
          class="btn btn-sm btn-primary ms-2"
          (click)="open(pledgesGrid.instance.getSelectedRowsData()[0].id)"
          [disabled]="pledgesGrid.instance.getSelectedRowsData().length !== 1"
          >
          Open
        </button>
        <button class="btn btn-sm btn-danger ms-2" [disabled]="pledgesGrid.instance.getSelectedRowsData().length !== 1" (click)="delete()">Delete</button>
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (pledges) {
          <span class="ms-4 me-3">
            <strong>{{ pledgesGrid.instance.totalCount() + ' items' }}</strong>
          </span>
        }
        @if (pledges) {
          <span class="me-3">
            <i (click)="openUnAssociatedPledges()">UnAssociated Givings {{ noAssociatedPledgeGivingTotal | currency }}</i>
          </span>
        }
      </div>
    </dx-data-grid>
  </div>
  <div class="d-flex flex-fill flex-column p-3 m-1">
    <dx-data-grid
      #linesGrid
      class="flex-fill"
      keyExpr="id"
      [dataSource]="lines"
      [height]="300"
      [columnAutoWidth]="true"
      [focusedRowEnabled]="false"
      [showBorders]="true"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      >
      <dxi-column dataField="pledge.person.displayNameLastFirst" caption="Person" [width]="500" [sortIndex]="1" [sortOrder]="'asc'" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="expectedDate" [width]="100" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="amount" [format]="{ type: 'currency', precision: 2 }" cellTemplate="linkTemplate"></dxi-column>

      <div *dxTemplate="let cell of 'linkTemplate'">
        <a [routerLink]="" (click)="open(cell.data.pledgeId)">{{ cell.text || '(blank)' }}</a>
      </div>

      <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'onClick'"></dxo-selection>
      <dxo-summary>
        <dxi-total-item column="amount" summaryType="sum" displayFormat="{0}" valueFormat="$#,##0.00"> </dxi-total-item>
      </dxo-summary>

      <div *dxTemplate="let data of 'toolbarButtons'">
        <button class="btn btn-sm btn-danger ms-4" (click)="printStatements()" >
          Print Yearly Statements
        </button>
        <button class="btn btn-sm btn-danger ms-4" (click)="printStatements(true)" >
          Print History Statements
        </button>
      </div>
      <div *dxTemplate="let data of 'toolbarText'"></div>
    </dx-data-grid>
  </div>
</div>
